import { createFileRoute } from '@tanstack/react-router';
import { CustomerioConnectorRouteView } from '@/pages/workspaces/journeys/integrations/customerio/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this connector.
 */
function CustomerioConnectorRoute() {
  return (
    <LastWorkspaceResolver>
      <CustomerioConnectorRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/customerio')({
  component: CustomerioConnectorRoute,
});
